import React,{useState,useEffect} from 'react'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import axios from 'axios';
import { optionssection, optionssemester } from '../../Helper'
import {BsSearch} from 'react-icons/bs'
import MobileInputSubComp from './sub_components/MobileInputSubComp'
const AssessmentPrintCompmb = () => {
    
    const [session, setsession] = useState("");
    const [myclass, setmyclass] = useState("");
    const [section,setsection] = useState("");
    const [semester,setsemester] = useState("");
    const [sessionlabel, setsessionlabel] = useState("");
    const [sessionvalueerr, setsessionvalueerr] = useState("");
    const [myclasslabel, setmyclasslabel] = useState("");
    const [myclassvalueerr, setmyclassvalueerr] = useState("");
    const [sectionlabel, setsectionlabel] = useState("");
    const [sectionvalueerr, setsectionvalueerr] = useState("");

    const handlePrint=()=>{

    }

    const [classresponse, setclassresponse] = useState([]);

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Methods": "*",
  }
    useEffect(() => {
      const fetchClassDropdown = async () => {
          try {
              const classresponse = await axios.get(
                  "https://sass.britishstandardschool.com/api/Public/ClassList",
                  {},
                  headers
              );
              setclassresponse(classresponse.data);
              // console.log(classresponse);
          } catch (err) {
              if (err.classresponse) {
                  console.error(err.classresponse.data);
                  console.log(err.classresponse.status);
                  console.log(err.classresponse.header);
              } else {
                  console.error(`Error: ${err.message}`);
              }
          }
      };
      fetchClassDropdown();
  }, []);

    const [sessionresponse, setsessionrsponse] = useState([]);
    useEffect(() => {
        const fetchSessionDropdown = async () => {
            try {
                const sessionresponse = await axios.get(
                    "https://sass.britishstandardschool.com/api/Public/SessionDropDown",
                    {},
                    headers
                );
                setsessionrsponse(sessionresponse.data);
                console.log(sessionresponse);
            } catch (err) {
                if (err.sessionresponse) {
                    console.error(err.sessionresponse.data);
                    console.log(err.sessionresponse.status);
                    console.log(err.sessionresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchSessionDropdown();
    }, []);

    const drpfuncsession=(myval,myid)=>{
        setsession(myid)
    }
    const drpfuncsection=(myval,myid)=>{
        setsection(myid)
    }
    const drpfuncclass=(myval,myid)=>{
        setmyclass(myid)
    }
    const drpfuncsemester=(myval,myid)=>{
        setsemester(myval)
    }
    const handleSearchclick =()=>{}
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Assessment Ptint</h3>
                </div>
                <div className="admbwrap pb0">
                    <Row>
                    <MobileInputSubComp col="6" direct="left" name="Session" >
                        <div className="dropdownwrapper">
                            <Dropdown2 err={sessionvalueerr === "err" ? "err" : ""} func={drpfuncsession} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={sessionresponse} />
                        </div>
                    </MobileInputSubComp>
                    <MobileInputSubComp col="6" direct="right" name="Class" >
                        <div className="dropdownwrapper">
                            <Dropdown2 err={myclassvalueerr === "err" ? "err" : ""} func={drpfuncclass} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={classresponse} />
                        </div>
                    </MobileInputSubComp>
                    <MobileInputSubComp col="6" direct="left" name="Section" >
                        <div className="dropdownwrapper">
                            <Dropdown2 err={sectionvalueerr === "err" ? "err" : ""} func={drpfuncsection} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssection} />
                        </div>
                    </MobileInputSubComp>
                    <MobileInputSubComp col="6" direct="left" name="Semester" >
                        <div className="dropdownwrapper">
                            <Dropdown2 func={drpfuncsemester} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionssemester} />
                        </div>
                    </MobileInputSubComp>
                    <Col xs={10} className="m-auto d-flex">

                        <Col xs={6} className="pr7">
                        <div className="basicinput">
                                <button className='cmbutton' onClick={handleSearchclick}>
                                    Search
                                </button>
                            </div>
                        </Col>
                        <Col xs={6} className="pl7">
                        <div className="basicinput">
                        <button className='cmbutton' onClick={handlePrint}> Print</button>
                        </div>
                        </Col>
                    </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default AssessmentPrintCompmb